<mat-label *ngIf="label">
  <span [innerHtml]="label"></span>
  <span class="indicator" *ngIf="control && control.hasValidator(required) && _processShellService.screenMode != 'rm-view-mode'">*</span>
  <span class="indicator" *ngIf="_processShellService.screenMode == 'rm-view-mode'">:</span>
</mat-label>
